// extracted by mini-css-extract-plugin
export var border = "_l-7";
export var brand = "_l-r";
export var button = "_l-j";
export var center = "_l-9";
export var centered = "_l-5";
export var closeButton = "_l-b";
export var disabledWrapper = "_l-k";
export var error = "_l-n";
export var extraLarge = "_l-4";
export var extraSmall = "_l-1";
export var fill = "_l-g";
export var footer = "_l-f";
export var footerAction = "_l-h";
export var footerButtons = "_l-i";
export var header = "_l-6";
export var icon = "_l-m";
export var info = "_l-q";
export var inline = "_l-8";
export var large = "_l-3";
export var main = "_l-c";
export var modal = "_l-0";
export var neutral = "_l-s";
export var noPadding = "_l-e";
export var none = "_l-t";
export var scrollable = "_l-d";
export var small = "_l-2";
export var success = "_l-p";
export var tight = "_l-l";
export var titleIcon = "_l-a";
export var warn = "_l-o";